import React, { useEffect, useState } from 'react'
import { Row, Col, Card, Form } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import Select from 'react-select';
import { Button } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import useScriptRef from '../../../../hooks/useScriptRef';
import upschoolLogo from '../../../../assets/images/UpSchoolSVG.svg';
import { useSelector, useDispatch } from 'react-redux'
import { UnitData, NoSubjectFound } from '../../../../redux/counterSlice'
import { getAllUnitData, getAllTeacherClasses, getAllTeacherSections, getAllTeacherSubjects } from '../../../../helper/commonApi'
import BasicSpinner from '../../../../helper/BasicSpinner';

const ClassSwitcher = () => {

    const history = useHistory();
    const scriptedRef = useScriptRef();
    const dispatch = useDispatch()

    const [classOptions, setClassOptions] = useState();
    const [sectionOptions, setSectionOptions] = useState();
    const [subjectOptions, setsubjectOptions] = useState();
    const [isNoSubjectFound, setIsNoSubjectFound] = useState(false);

    const [defaultclassOption, setDefaultclassOption] = useState();
    const [defaultsectionOption, setDefaultSectionOption] = useState();
    const [defaultsubjectOption, setDefaultSubjectOption] = useState();
    const isClassError = useSelector((state) => state.teacherIds.classError);

    const getAllUnitDataBasedOnSubject = async (subjectid) => {
        const allUnitData = await getAllUnitData(subjectid);
        if (allUnitData.Error) {
            console.log("allUnitData.Error", allUnitData.Error);
        } else {
            var unitAllData = allUnitData
            dispatch(UnitData(unitAllData))
            history.replace('/teacher-portal/dashboard');
            window.location.reload();
        }
    }

    const fecthAllTeacherClass = async (teacher_id, section_id) => {
        dispatch(UnitData([]))
        const allClass = await getAllTeacherClasses(teacher_id);
        if (allClass.Error) {
            console.log(allClass.Error?.response?.data);
            if (allClass.Error.response.data === "Invalid Token") {
                sessionStorage.clear();
                localStorage.clear();
                history.push('/auth/signin-1');
            } else {
                console.log(allClass.Error);
            }
        } else {
            var resultData = allClass.Items
            console.log("resultClass", resultData);
            var classData = []
            resultData?.forEach((item, index) => {
                classData.push({ value: item.client_class_id, label: item.client_class_name })
            })
            const defaultClass = classData.find(item => item.value === sessionStorage.getItem("client_class_id"))
            setDefaultclassOption(defaultClass)
            setClassOptions(classData)
        }
    }

    const fecthAllTeacherSections = async (teacher_id, client_class_id) => {
        const allSection = await getAllTeacherSections(teacher_id, client_class_id);
        if (allSection.Error) {
            console.log(allSection.Error?.response?.data);
            if (allSection.Error.response.data === "Invalid Token") {
                sessionStorage.clear();
                localStorage.clear();
                history.push('/auth/signin-1');
            } else {
                console.log(allSection.Error);
            }
        } else {
            var resultData = allSection.Items
            console.log("resultSection", resultData);
            var sectionData = []
            resultData.forEach((item, index) => {
                sectionData.push({ value: item.section_id, label: item.section_name })
            })
            const defaultSection = sectionData.find(item => item.value === sessionStorage.getItem("section_id"))
            setDefaultSectionOption(defaultSection)
            setSectionOptions(sectionData)
        }
    }


    const fecthAllTeacherSubjects = async (teacher_id, client_class_id, section_id) => {
        const allSubject = await getAllTeacherSubjects(teacher_id, client_class_id, section_id);
        if (allSubject.Error) {
            console.log(allSubject.Error.response.data);
            if (allSubject.Error?.response?.data === "Invalid Token") {
                sessionStorage.clear();
                localStorage.clear();
                history.push('/auth/signin-1');
            } else if (allSubject.Error.response.data === 'No Subjects found') {
                setIsNoSubjectFound(true)
                dispatch(NoSubjectFound(allSubject.Error.response.data))
            } else {
                console.log(allSubject.Error);
            }
        } else {
            var resultData = allSubject.Items
            console.log("resulSubject", resultData);
            var subjectData = []
            resultData.forEach((item, index) => {
                subjectData.push({ value: item.subject_id, label: item.display_name })
            })
            const defaultSubject = subjectData.find(item => item.value === sessionStorage.getItem("subject_id"))
            setDefaultSubjectOption(defaultSubject)
            setsubjectOptions(subjectData)
        }
    }





    useEffect(() => {
        const validateJWT = sessionStorage.getItem('user_jwt');
        if (validateJWT === "" ||
            validateJWT === null ||
            validateJWT === undefined ||
            validateJWT === "undefined"
        ) {
            sessionStorage.clear();
            localStorage.clear();
            history.push('/auth/signin-1');
            window.location.reload();
        } else {
            const teacher_id = sessionStorage.getItem('teacher_id')
            const client_class_id = sessionStorage.getItem('client_class_id')
            const section_id = sessionStorage.getItem('section_id')
            const subject_id = sessionStorage.getItem('subject_id')
            fecthAllTeacherClass(teacher_id, section_id)
            fecthAllTeacherSections(teacher_id, client_class_id)
            fecthAllTeacherSubjects(teacher_id, client_class_id, section_id)
        }
    }, []);

    return (
        <React.Fragment>
            <Row>
                <Col>
                    <div className='mt-4 mb-3'>
                        <div>
                            <Formik
                                initialValues={{
                                    class: '',
                                    section: '',
                                    subject: ''
                                }}

                                validationSchema={Yup.object().shape({
                                    class: Yup.string()
                                        .min(1, 'Select any class!')
                                        .required('Class is required!'),

                                    section: Yup.string()
                                        .min(1, 'Select any class!')
                                        .required('Section is required!'),


                                    subject: Yup.string()
                                        .min(1, 'Select any class!')
                                        .required('Subject is required!')
                                })}

                                onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                                    try {
                                        console.log(values);

                                        // history.push('/app/dashboard/analytics')
                                    } catch (err) {
                                        console.error(err);
                                        if (scriptedRef.current) {
                                            setStatus({ success: false });
                                            setErrors({ submit: err.message });
                                            setSubmitting(false);
                                        }
                                    }
                                }}
                            >
                                {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
                                    <form onSubmit={handleSubmit}>

                                        <Card
                                            style={{
                                                backgroundColor: '#ffff',
                                                border: '1px solid #ffff',
                                                zIndex: 5
                                            }}>
                                            <div style={{ display: 'contents' }} >
                                                <img width={30} style={{ marginTop: '17px', marginLeft: '10px' }} src={upschoolLogo} alt="" className="img-fluid mb-4" />
                                                <p style={{ textAlign: 'end', marginTop: '-62px', marginRight: '15px' }} >You are accessing</p>
                                                <h6 style={{ textAlign: 'center', marginTop: '-13px', marginLeft: '44px' }}>
                                                    {/* {"Some International School"} */}
                                                    {sessionStorage.getItem("school_name")}

                                                </h6>
                                            </div>
                                            <Card
                                                style={{
                                                    backgroundColor: '#ffff',
                                                    border: '1px solid #ffff',
                                                    margin: "10px"
                                                }}
                                            >


                                                <Card.Body style={{ padding: '6px' }}>

                                                    <div className="form-group fill">
                                                        <label className="floating-label" >
                                                            <small className="text-danger">* </small>
                                                            Class
                                                        </label>
                                                        {classOptions && (
                                                            <Select
                                                                defaultValue={defaultclassOption}
                                                                className="basic-single"
                                                                classNamePrefix="select"
                                                                name="color"
                                                                options={classOptions}
                                                                onChange={(e) => {
                                                                    dispatch(UnitData([]))
                                                                    dispatch(NoSubjectFound(""))
                                                                    fecthAllTeacherSections(sessionStorage.getItem('teacher_id'), e.value);
                                                                    sessionStorage.setItem("client_class_id", e.value);
                                                                    sessionStorage.setItem("section_id", "");
                                                                    sessionStorage.setItem("subject_id", "");
                                                                    setSectionOptions('');
                                                                    setsubjectOptions('');
                                                                    setIsNoSubjectFound(false)
                                                                }}
                                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                            />
                                                        )}
                                                    </div>

                                                    {touched.class && errors.class ? (
                                                        <small style={{ color: 'red' }}>{errors.class}</small>
                                                    ) : null}
                                                    {/* {isClassError === true ? (<small style={{ color: 'red' }}>Select Class</small>) : null} */}


                                                    <div className="form-group fill">
                                                        <label className="floating-label" >
                                                            <small className="text-danger">* </small>
                                                            Section
                                                        </label>
                                                        {sectionOptions && (
                                                            <Select
                                                                defaultValue={defaultsectionOption}
                                                                className="basic-single"
                                                                classNamePrefix="select"
                                                                name="color"
                                                                options={sectionOptions}
                                                                onChange={(e) => {
                                                                    dispatch(NoSubjectFound(""))
                                                                    fecthAllTeacherSubjects(sessionStorage.getItem('teacher_id'), sessionStorage.getItem('client_class_id'), e.value);
                                                                    sessionStorage.setItem("section_id", e.value);
                                                                    sessionStorage.setItem("subject_id", "");
                                                                    setsubjectOptions('');
                                                                    setIsNoSubjectFound(false)
                                                                }}
                                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}

                                                            />
                                                        )}

                                                    </div>


                                                    {touched.section && errors.section ? (
                                                        <small style={{ color: 'red' }}>{errors.section}</small>
                                                    ) : null}
                                                    {/* {isClassError === true ? (<small style={{ color: 'red' }}>Select Section</small>) : null} */}


                                                    <div className="form-group fill" >
                                                        <label className="floating-label" >
                                                            <small className="text-danger">* </small>
                                                            subject
                                                        </label>
                                                        {subjectOptions && (
                                                            <Select
                                                                styles={{ zIndex: '100' }}
                                                                defaultValue={defaultsubjectOption}
                                                                className="basic-single"
                                                                classNamePrefix="select"
                                                                name="color"
                                                                options={subjectOptions}
                                                                onChange={(e) => {
                                                                    sessionStorage.setItem("subject_id", e.value);
                                                                    getAllUnitDataBasedOnSubject(e.value);

                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                    {isNoSubjectFound && (
                                                        <small style={{ color: 'red' }}>No Subjects found</small>
                                                    )}
                                                    {touched.subject && errors.subject ? (
                                                        <small style={{ color: 'red' }}>{errors.subject}</small>
                                                    ) : null}
                                                    {/* {isClassError === true ? (<small style={{ color: 'red' }}>Select Subject</small>) : null} */}
                                                </Card.Body>

                                            </Card>
                                        </Card>
                                    </form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </Col>
            </Row>
        </React.Fragment>

    );
};

export default ClassSwitcher